import { ethers as ethers$1 } from 'ethers';
import { ethers } from 'ethersV6';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const isV6EthersProvider = /* @__PURE__ */ __name((provider) => {
  if (provider?._isProvider === true) {
    return false;
  } else if (provider?.provider && provider?.signTransaction) {
    return isV6EthersProvider(provider.provider);
  } else if (provider?.provider && !provider?.signTransaction) {
    return true;
  }
  throw new Error("Unknown provider type");
}, "isV6EthersProvider");
const getEthersContractFromProvider = /* @__PURE__ */ __name((provider) => {
  return isV6EthersProvider(provider) ? ethers.Contract : ethers$1.Contract;
}, "getEthersContractFromProvider");

export { getEthersContractFromProvider, isV6EthersProvider };
